import React from 'react';
import HealthData from './HealthData';
import DiabetesHealthDataFilterForm from './Filter/DiabetesHealthDataFilterForm';

interface DiabetesHealthDataProps {
	patientId: string;
}

const DiabetesHealthData: React.FC<DiabetesHealthDataProps> = props => (
	<HealthData {...props} FilterComponent={DiabetesHealthDataFilterForm} />
);

export default DiabetesHealthData;
